import { render, staticRenderFns } from "./AttachExistingExerciseDialog.vue?vue&type=template&id=2116b127&"
import script from "./AttachExistingExerciseDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachExistingExerciseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports